// ТЕКСТЫ ЭКРАНА 404 — три слота борда CD `Life Map - Stub Screens v2.html` (дроп
// `drop-stubs-30-09/`, принят Кириллом 30.09). Тикет `3eb19875cbb881bb9a04e503ee488d31`, п.2.
//
// ИСТОЧНИК БУКВЫ — борд: редакция CD 30.09 после решения web-Claude, строчные, апостроф в `isn’t`
// кручёный U+2019 (`s711.d2`). Перенос буква-в-букву. Правка текста идёт в Notion, сюда приезжает
// следом — как у `errorCopy.js`.
//
// ⚠️ `wiz.notfound.action` — строчными и без стрелки: регистр и `→` даёт CSS (`.wz-cta`), как у
// `continue` и `reload`. Кнопка ведёт на начало визарда `/` (`s944.d1`) и конверт не трогает.

export const NOT_FOUND_COPY = {
  'wiz.notfound.title': 'this page isn’t here.',
  'wiz.notfound.body': 'the link may be old or mistyped.',
  'wiz.notfound.action': 'start your map',
};
